module.exports = __webpack_public_path__ + "static/media/sombra-inferior.82013d6f.svg";